module.exports = __webpack_public_path__ + "static/media/empty-profile.d0265dd4.png";